export default "__VITE_ASSET__e8159aca__"